import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrashAlt, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import AddRowForm from './addrowform.js';
import RemoveRowForm from './removerowform.js';
import RowSummary from './rowsummary.js';
import Box from '../../ui/Box.js';
import api from '../../../api/index.js';
import Loadable from '../../ui/loading/Loadable.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import ConfirmUI from '../../ui/Confirm.js';


class RowDisplay extends Component {
	constructor(props) {
		super(props);
		this.state = {
			interfaceOpen: false,
			removeRowInterface: false,
			units: false
		}
	}
	
	addRowsFormOpen = () => {
		this.setState({interfaceOpen: 'add'});
	}
	
	closeInterface = () => {
		this.setState({interfaceOpen: false});
	}
	
	discontinueRowsFormClick = () => {
		confirmAlert({
			title: 'Discontinue rows',
			customUI: ConfirmUI(
				this.discontinueRowsFormOpen,
				<div><p>This will remove rows from the list, but they'll be preserved in historical data.  It is the safest way to be rid of a rows.</p><p><em>Are you sure to discontinue rows?</em></p></div>
			),
		});
	}
	
	discontinueRowsFormOpen = () => {
		this.setState({interfaceOpen: 'discontinue'});
	}

	
	deleteRowsFormClick = () => {
		confirmAlert({
			title: 'Delete rows from the system',
			customUI: ConfirmUI(
				this.deleteRowsFormOpen,
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a row by mistake. Are you sure you want to do this?</p></div>
			),
		});
	}
	
	
	deleteRowsFormOpen = () => {
		this.setState({interfaceOpen: 'delete'});
	}
	
	
	async refresh() {
		this.setState({units: await api.settings.get('display_units')});
	}
	

	
	componentDidMount() {
		this.refresh();
		// Get the thing from the api
	}
	
	onChange = () => {
		if (this.props.onChange)
			this.props.onChange();
	}
	
	onAdded = () => {
		this.closeInterface();
		this.onChange();
	}
	
	
	rowsorter(a, b) {
		// Put discontinued rows at the bottom		
		if (a.props.discontinued && !b.props.discontinued)
			return 1;
		if (!a.props.discontinued && b.props.discontinued)
			return -1;
		
		if (isNaN(a.props.row.RowNumber) && isNaN(b.props.row.RowNumber))
			return a.props.row.RowNumber - b.props.row.RowNumber;
		if (!isNaN(a.props.row.RowNumber) && !isNaN(b.props.row.RowNumber))
			return parseFloat(a.props.row.RowNumber) - parseFloat(b.props.row.RowNumber);
		if (isNaN(a.props.row.RowNumber))
			return -1;
		if (isNaN(b.props.row.RowNumber))
			return -1;
		return 0;
	}
	
	
	render() {
		// Figure out the max row length..  Everything will be sized by percentages of that.
		const max = this.props.rows.reduce((accumulator, currentValue) => parseFloat(currentValue.RowLength) > accumulator ? parseFloat(currentValue.RowLength) : accumulator, 0);
		
		// Also we need field information, like plant spacing
		let rows = [];
		for(let i=0; i < this.props.rows.length; i++) {
			rows.push(<RowSummary key={i} 
				row={this.props.rows[i]} 
				max={max} 
				field={this.props.field} 
				deadPlants={this.props.rows[i].DeadPlantNum} 
				displayUnits={this.state.units} 
				onChange={this.onChange} 
				discontinued={api.isCurrentlyDisabled(this.props.rows[i].DiscontinuedDate)}
			/>);
		}
		rows = rows.sort(this.rowsorter);
		
		return (<Box title="Rows" options={[
			{
				label: <span><FontAwesomeIcon icon={faPlus} className="addIcon" /> Add new rows</span>,
				callback: this.addRowsFormOpen
			},
			{
				label: <span><FontAwesomeIcon icon={faTrashAlt} className="deleteIcon" /> Discontinue rows</span>,
				callback: this.discontinueRowsFormClick,
				separator: true
			},
			{
				label: <span><FontAwesomeIcon icon={faExclamationTriangle} className="exclaimIcon" /> <small>Actually <strong>delete</strong> rows from the system</small></span>,
				callback: this.deleteRowsFormClick
			}

		]}>
			<Box 
				modal={true}
				isOpen={this.state.interfaceOpen === 'add'}
				onRequestClose={this.closeInterface}
				title={"Add rows"}
			>
				<AddRowForm FieldID={this.props.field.FieldID} FarmID={this.props.field.FarmID} field={this.props.field} onAdded={this.onAdded} />
			</Box>
			<Box 
				modal={true}
				isOpen={this.state.interfaceOpen === 'delete' || this.state.interfaceOpen === 'discontinue' }
				onRequestClose={this.closeInterface}
				title={(this.state.interfaceOpen || '').toUpperCase() + " rows"}
			>
				<RemoveRowForm FieldID={this.props.field.FieldID} FarmID={this.props.field.FarmID} mode={this.state.interfaceOpen} onRemoved={this.onAdded} />
			</Box>
			
				{/* SHow row summaries, sorted by rownumber */}
				<Loadable ready={this.state.units !== false}>
					<div className="rows">{rows}</div>
				</Loadable>

		</Box>);
	}
}


export default RowDisplay;